import React from 'react'
import {AllUserRoles, CompanyRoles} from 'Authority'
import RouteConstant from 'constants/RouteConstant'
import CommonLayout from 'layouts/Common'
import {Redirect, Route, Switch} from 'react-router-dom'
import RouteIf from 'routes/RouteIf'

import PurchaseHistoryList from 'pages/ProductHistory/PurchaseHistoryList'
import PurchaseHistoryDetail from 'pages/ProductHistory/PurchaseHistoryDetail'

export default function ProductPurchaseHistoryRoute() {
  return (
    <CommonLayout>
      <Switch>
        <RouteIf
          requiredRoles={AllUserRoles}
          path={RouteConstant.PRODUCTS_PURCHASE_HISTORY.path}
          exact
          component={PurchaseHistoryList}
        />
        <RouteIf
          requiredRoles={AllUserRoles}
          path={RouteConstant.PRODUCTS_PURCHASE_DETAIL.path}
          exact
          component={PurchaseHistoryDetail}
        />
        <RouteIf
          requiredRoles={AllUserRoles}
          path={RouteConstant.PRODUCTS_CANCELLATION_PURCHASE_DETAIL.path}
          exact
          component={PurchaseHistoryDetail}
        />

        <Route path='*'>
          <Redirect to={RouteConstant.ERROR_NOT_FOUND.path} />
        </Route>
      </Switch>
    </CommonLayout>
  )
}
